import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
/** Will open the tier popup in edit mode if given a deviation
 *  or in create mode if given none */
export default function useTierPopup(deviation) {
    var dispatch = useDispatch();
    return useCallback(function () {
        return dispatch(pushModal(ModalType.TIER_EDIT, {
            wrapInModal: false,
            params: { deviation: deviation },
        }));
    }, [dispatch, deviation]);
}
//# sourceMappingURL=useTierPopup.js.map